export default __webpack_public_path__ + "static/media/spacecowboy2.d98d086e.gif";